// URLs das SPAs irmãs — usado para montar o link de primeiro acesso.
//
// F3-C: cada SPA (comitê/admin/recurso) hospeda a tela #first-access (shell
// compartilhado @aions/ui-primitives FirstAccessForm).
//
// F5 item 4 (2026-06-17): o link agora aponta para o subdomínio DO PAPEL do
// membro — admin_ti → admin SPA, comite_recurso → recurso SPA, comite_membro →
// comitê — para o membro ativar e já cair no painel dele. O endpoint
// /api/comite/first-access continua ROLE-AGNOSTIC (qualquer papel ativa pelo
// mesmo backend); só o ALVO do link passou a ser por papel. As base-URLs vêm de
// VITE_*_BASE_URL (web-admin/.env.production), destravadas pela conta Cloudflare
// (Pages .pages.dev).
//
// Dev/test: VITE_*_BASE_URL ausentes → fallback localhost (portas dev:
// comite 5174, admin 5175, recurso 5176).

const COMITE_BASE = import.meta.env.VITE_COMITE_BASE_URL ?? 'http://localhost:5174';
const ADMIN_BASE = import.meta.env.VITE_ADMIN_BASE_URL ?? 'http://localhost:5175';
const RECURSO_BASE = import.meta.env.VITE_RECURSO_BASE_URL ?? 'http://localhost:5176';

// Precedência papel → SPA de ativação. O universo real é single-papel por pessoa;
// um membro multi-papel (raro) cai no mais especializado primeiro. cofre_holder e
// qualquer papel desconhecido caem no comitê (default role-agnostic, paridade do
// comportamento pré-F5). JUDGMENT CALL: ordem admin_ti > comite_recurso >
// comite_membro — revisar se o modelo de papéis combinados mudar.
function baseForRoles(roles: readonly string[]): string {
  if (roles.includes('admin_ti')) return ADMIN_BASE;
  if (roles.includes('comite_recurso')) return RECURSO_BASE;
  if (roles.includes('comite_membro')) return COMITE_BASE;
  return COMITE_BASE; // default role-agnostic (cofre_holder / papel desconhecido)
}

/** Monta o link de primeiro acesso apontando para a SPA do PAPEL do membro.
 *  otpAuthUri opcional (embute o QR no link). */
export function firstAccessUrl(
  roles: readonly string[],
  token: string,
  email: string,
  otpAuthUri?: string,
): string {
  const base = baseForRoles(roles);
  const params = new URLSearchParams({ token, email });
  if (otpAuthUri) params.set('otp', otpAuthUri);
  return `${base}/#first-access?${params.toString()}`;
}

/** Wrapper role-agnostic (alvo = comitê). Usado quando o papel NÃO está disponível
 *  no callsite — ex.: aprovação de credential-reset, cujo item não carrega `roles`
 *  client-side. Mantém o comportamento pré-F5 (link aponta ao comitê) para esse
 *  fluxo; o membro ativa pelo backend role-agnostic e navega ao painel dele. */
export function comiteFirstAccessUrl(token: string, email: string, otpAuthUri?: string): string {
  return firstAccessUrl(['comite_membro'], token, email, otpAuthUri);
}
